import * as yup from 'yup';
import { sdkConfigurationSchema } from './sdkConfiguration';
import platformDeploymentSchema from './platformDeployment';
import { indexedObject } from '../_helpers';

const partnerSpecificSettings = yup.object().shape({
  taskboxMessage: yup.string(),
  settingsIndexed: indexedObject(
    yup.object({
      botBreakMessage: yup // Required (at least 1 inside array)
        .array()
        .required()
        .of(yup.string()),
      outlierMessage: yup // Required (at least 1 inside array)
        .array()
        .required()
        .of(yup.string()),
      platformDeployments: indexedObject(platformDeploymentSchema),
      sdkConfiguration: sdkConfigurationSchema,
      taskboxSettings: yup.object().shape({
        tasks: indexedObject(
          yup.object().shape({
            active: yup.bool(),
            image_url: yup.string(),
          })
        ),
      }),
    })
  ),
  allTasks: yup.array().of(
    yup.object().shape({
      id: yup.mixed().required(), // required
      is_taskbox_supported: yup.bool(),
      is_tasklist_supported: yup.bool(),
      location_required: yup.bool(),
      message: yup.string().required(), // required -- strip off {task},
      name: yup.string().required(), // required,
    })
  ),
});

export default partnerSpecificSettings;
